import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=facb8804&scoped=true&"
import script from "./ModalLogin.vue?vue&type=script&lang=js&"
export * from "./ModalLogin.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogin.vue?vue&type=style&index=0&id=facb8804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facb8804",
  null
  
)

export default component.exports